import type { IsDemoProjectState } from './types.tsx';

export const initialIsDemoProjectState: IsDemoProjectState = {
	data: null,
	loading: false,
	error: null,
};
